module.exports = __webpack_public_path__ + "static/img/LEVI-ASHCROFT.55ccdf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LEVI-ASHCROFT.jpg
// module id = BKN6
// module chunks = 0